import { motion } from "framer-motion";

const BOXES = [
  { left: "40%", top: "44%", delay: 0, dur: 3.6, size: 52, drift: 30, spin: 200 },
  { left: "52%", top: "48%", delay: 0.9, dur: 4.2, size: 40, drift: 64, spin: -170 },
  { left: "46%", top: "46%", delay: 1.8, dur: 3.9, size: 46, drift: 4, spin: 240 },
  { left: "58%", top: "50%", delay: 2.6, dur: 4.4, size: 34, drift: 84, spin: -130 },
];

function FallingBox({ left, top, delay, dur, size, drift, spin }) {
  return (
    <motion.img
      src="/box.png"
      alt=""
      aria-hidden
      className="absolute z-0 select-none"
      style={{ left, top, width: size, filter: "drop-shadow(0 14px 18px rgba(0,0,0,0.28))" }}
      initial={{ y: 0, x: 0, opacity: 0, rotate: 0, scale: 0.75 }}
      animate={{ y: ["0%", "18%", "320%"], x: [0, drift * 0.4, drift], opacity: [0, 1, 1, 0], rotate: [0, spin * 0.4, spin], scale: [0.75, 1, 1.1] }}
      transition={{ duration: dur, delay, repeat: Infinity, ease: "easeIn", times: [0, 0.15, 1] }}
    />
  );
}

export default function PlaneScene({ className = "" }) {
  return (
    <div className={`relative aspect-[5/4] w-full ${className}`} data-testid="plane-scene">
      {/* soft brand glow behind the plane */}
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[85%] w-[85%] -translate-x-1/2 -translate-y-1/2 glow-purple blur-2xl opacity-80" />

      {/* dashed flight trail */}
      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none">
        <motion.path d="M 6 86 Q 34 58 62 30" fill="none" stroke="rgba(90,24,154,0.35)" strokeWidth="0.5"
          strokeDasharray="2 3" initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 1.6, delay: 0.5 }} />
      </svg>

      {/* dropping boxes (behind the plane so they read as leaving the cargo hold) */}
      {BOXES.map((b, i) => <FallingBox key={i} {...b} />)}

      {/* realistic purple cargo plane */}
      <motion.img
        src="/plane.png"
        alt="XPRESSNGOSHIP purple cargo aircraft"
        className="absolute left-1/2 top-[10%] z-10 w-[104%] -translate-x-1/2 select-none"
        style={{ filter: "drop-shadow(0 30px 46px rgba(61,10,110,0.4))" }}
        initial={{ opacity: 0, scale: 0.92, y: 12 }}
        animate={{ opacity: 1, scale: 1, y: [0, -12, 0], rotate: [0, -1.2, 0] }}
        transition={{ opacity: { duration: 0.8, delay: 0.3 }, scale: { duration: 0.8, delay: 0.3 }, y: { duration: 6.5, repeat: Infinity, ease: "easeInOut", delay: 0.9 }, rotate: { duration: 6.5, repeat: Infinity, ease: "easeInOut", delay: 0.9 } }}
      />
    </div>
  );
}
